export default class Trace {
    static enabled = false;

    static print(msg) {
        if (this.enabled) console.log(JSON.stringify(msg, null, 2));
    }

    static log(msg) {
        if (this.enabled) console.log(msg);
    }

    static info(msg) {
        if (this.enabled) console.info(msg);
    }

    static debug(msg) {
        if (this.enabled) console.debug(msg);
    }

    static warn(msg) {
        if (this.enabled) console.warn(msg);
    }

    static error(msg) {
        console.error(msg);

        // if (window.gbugs && window.gbugs.notify) window.gbugs.notify({ message: msg });
    }

    static trace(data) {
        if (this.enabled) console.trace(data);
    }

    static table(data) {
        if (this.enabled) console.table(data);
    }

    static alert(msg) {
        if (this.enabled) alert(msg);
    }
}
